<template>
  <div>
    <h1>抄送我的</h1>
  </div>
</template>

<script>
  export default {
     name: 'Copy',
     data () {
       return {
        
       }
     },
     methods: {

     }
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Wait/Copy.vue